import { appVoter, oauthScopeVoter } from "@verbleif/shared/src/composables/Permissions/SharedPermissions";

export const SettingsRoutes = [
  {
    path: "/settings",
    name: "settings",
    component: () => import("@cms/features/Settings/SettingsContainer.vue"),
    redirect: { name: "settings-roles" },
    children: [
      {
        path: "users/:dialog?",
        name: "users",
        component: () => import("@cms/features/Users/GlobalUsersOverview.vue"),
      },
      {
        path: "roles/:dialog?",
        name: "settings-roles",
        component: () =>
          import("@cms/features/PermissionTemplateGroups/GlobalPermissionTemplateGroupsOverview.vue"),
      },
      {
        path: "apps",
        name: "settings-apps",
        component: () => import("@cms/features/Appstore/GlobalAppsAdminOverview.vue"),
        beforeEnter: () => (appVoter.canRead({}) ? true : { name: "settings" }),
      },
      {
        path: "app-subscriptions/:appSubscriptionId?/:tab?",
        name: "settings-app-subscriptions",
        component: () => import("@cms/features/Appstore/GlobalAppSubscriptionsOverview.vue"),
        // Opens without the right too: the page shows its no access state, and the API keeps the data protected.
      },
      {
        path: "app-review",
        name: "settings-app-review",
        component: () => import("@cms/features/Appstore/GlobalAppReviewQueue.vue"),
        // Opens without the right too: the page shows its no access state, and the API keeps the data protected.
      },
      {
        path: "developer-access-requests/:requestId?",
        name: "settings-developer-access-requests",
        component: () => import("@cms/features/DeveloperAccessRequests/DeveloperAccessRequestsOverview.vue"),
        // Opens without the right too: the page shows its no access state, and the API keeps the data protected.
      },
      {
        path: "app-credentials/:credentialId?",
        name: "settings-app-credentials",
        component: () => import("@cms/features/Appstore/GlobalAppCredentialsOverview.vue"),
        // Opens without the right too: the page shows its no access state, and the API keeps the data protected.
      },
      {
        path: "oauth-scopes",
        name: "settings-oauth-scopes",
        component: () => import("@verbleif/shared/src/composables/OAuthScopes/OAuthScopesOverview.vue"),
        beforeEnter: () => (oauthScopeVoter.canRead() ? true : { name: "settings" }),
      },
      {
        path: "app-logs",
        name: "settings-app-logs",
        component: () => import("@cms/features/Appstore/GlobalAppTrafficLogsOverview.vue"),
      },
      {
        path: "inbound-rate-limit",
        name: "settings-inbound-rate-limit",
        component: () => import("@cms/features/Appstore/GlobalInboundRateLimitOverview.vue"),
        beforeEnter: () => (appVoter.canReadRateLimit() ? true : { name: "settings" }),
      },
      {
        path: "notifications",
        name: "settings-notifications",
        component: () => import("@cms/features/Notifications/NotificationsOverview.vue"),
      },
      {
        path: "user-preferences",
        name: "settings-user-preferences",
        component: () => import("@cms/features/Settings/GlobalUserPreferencesOverview.vue"),
      },
      {
        path: "view-defaults",
        name: "settings-view-defaults",
        component: () => import("@cms/features/Settings/GlobalViewsOverview.vue"),
      },
      {
        path: "email-event-logs",
        name: "settings-email-event-logs",
        component: () => import("@cms/features/EmailEventLogs/EmailEventLogsOverview.vue"),
      },
      {
        path: "tours",
        name: "settings-tours",
        component: () => import("@cms/features/Tours/ToursOverview.vue"),
      },
      {
        path: "whatsapp/:conversationId?",
        name: "settings-whatsapp",
        component: () => import("@cms/features/WhatsApp/WhatsAppInbox.vue"),
      },
      {
        path: "whatsapp-numbers",
        name: "settings-whatsapp-numbers",
        component: () => import("@cms/features/WhatsApp/WhatsAppPhoneNumbers.vue"),
      },
      {
        path: "ai",
        name: "settings-ai",
        component: () => import("@cms/features/Ai/AiSettingsOverview.vue"),
      },
      {
        path: "ai-logs",
        name: "settings-ai-logs",
        component: () => import("@cms/features/Ai/AiLogsOverview.vue"),
      },
    ],
  },
];
